// src/components/ProtectedRoute.jsx
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ allowedRoles, children }) {
  const { user, loading } = useAuth();
  if (loading) return null; // or a spinner

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // `user.ROLE_NAME` now holds the exact string from the DB
  if (!allowedRoles.includes(user.ROLE_NAME)) {
    return <Navigate to="/" replace />;
  }
  return children;
}


